import { render, staticRenderFns } from "./PublicDisplayConfigView.vue?vue&type=template&id=6430862c"
import script from "./PublicDisplayConfigView.vue?vue&type=script&lang=js"
export * from "./PublicDisplayConfigView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6430862c')) {
      api.createRecord('6430862c', component.options)
    } else {
      api.reload('6430862c', component.options)
    }
    module.hot.accept("./PublicDisplayConfigView.vue?vue&type=template&id=6430862c", function () {
      api.rerender('6430862c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PublicDisplay/PublicDisplayConfigView.vue"
export default component.exports